import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';
import { ButtonInLink } from '@hivebrite/design-system/ButtonInLink';
import { useToggle } from '@hivebrite/react-hooks';

import EndRelationshipModal from 'hb-react/frontoffice/apps/Mentoring/components/EndRelationshipModal';
import {
  type Program,
  type SharedCardProfile,
} from 'hb-react/frontoffice/apps/Mentoring/types';
import { useShouldDisplayInternalMessagingAction } from 'hb-react/frontoffice/utils/messaging';

interface AcceptedProps {
  program: Program;
  relationshipWithCurrentUser: SharedCardProfile['relationship_with_current_user'];
  userId: number;
}

const Accepted = ({
  relationshipWithCurrentUser,
  userId,
  program,
}: AcceptedProps) => {
  const { isOpen, open, close } = useToggle();
  const displayMessagingButton = useShouldDisplayInternalMessagingAction({
    user: { id: userId },
  });

  const displayEndRelationshipButton = !!relationshipWithCurrentUser?.id;

  return (
    <Wrapper>
      {displayEndRelationshipButton && (
        <>
          <Button variant="secondary" onClick={open} isFullWidth>
            {s__('Mentoring|End relationship')}
          </Button>
          {isOpen && (
            <EndRelationshipModal
              onCloseModal={close}
              program={program}
              relationshipId={relationshipWithCurrentUser.id}
            />
          )}
        </>
      )}
      {displayMessagingButton && (
        <ButtonInLink
          isFullWidth
          linkProps={{
            to: Routes.messaging_new_conversation_path({
              recipient_ids: userId,
            }),
          }}
        >
          {s__('Mentoring|Send message')}
        </ButtonInLink>
      )}
    </Wrapper>
  );
};

export default Accepted;

const Wrapper = styled(Box)`
  flex-flow: column;
  margin-top: auto;
  padding-top: ${({ theme }) => `${theme.space[4]}px`};
  gap: ${({ theme }) => `${theme.space[3]}px`};
`;
